import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@app/shell/footer/footer.component';
import { SideComponent } from '@app/shell/side/side.component';

@Component({
  selector: 'zero-waste-public-shell',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, SideComponent],
  templateUrl: './private-shell.component.html',
  styleUrls: ['./private-shell.component.scss'],
})
export class PrivateShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
